import React, { Component } from 'react';
import {
  withRouter,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { connect } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';
import * as Sentry from '@sentry/browser';

// import asyncComponent from './common/components/asyncComponent';
import * as authActions from './auth/actions';
import Layout from './main/components/Layout';

import Home from './main/containers/Home';
import SiteSelect from './main/containers/SelectSite';
import Login from './auth/containers/Login';
import PasswordReset from './auth/containers/PasswordReset';
import SetPassword from './auth/containers/SetPassword';
import FBCallback from './auth/containers/FBCallback';
import ConnectSocialAuth from './auth/containers/ConnectSocialAuth';
import CompleteProfile from './profile/containers/CompleteProfile';
import ProfileStatus from './profile/containers/ProfileStatus';
import DashHome from './dashboard/containers/Home';
import ViewProfile from './profile/containers/ViewProfile';
import EditProfile from './profile/containers/EditProfile';
import PrintProfile from './profile/containers/PrintProfile';
import Activities from './activities/containers/Activities';
import ManageActivityItem from './activities/containers/ManageActivityItem';
import SearchForm from './search/containers/SearchForm';
import Search from './search/containers/Search';
import SavedSearch from './search/containers/SavedSearch';
import News from './main/containers/News';
import Events from './main/containers/Events';
import EventDetail from './main/containers/EventDetail';
import NewsDetail from './main/containers/NewsDetail';
import StaticPages from './main/components/StaticPages';
import DeleteProfile from './profile/containers/DeleteProfile';
import Gallery from './main/containers/Gallery';
import FAQs from './main/components/FAQs';
import GalleryDetail from './main/containers/GalleryDetail';
import DisclaimersMenu from "./auth/components/DisclaimersMenu";
import TermsAndConditions from "./main/containers/TermsAndConditions"

import * as routes from './config/routes';
import classes from './css/getCSS';
import { getAuthHeaders } from "./auth/actions";
import axios from "./config/axios";
import Axios from "axios";
import * as profileActions from './profile/actions';
import { formatRoute } from "react-router-named-routes";

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://4fe74385e6124ba895410d81ecf2b56c@sentry.io/1315124',
  });
}


class App extends Component {

  componentWillMount() {
    this.props.checkAuth();
  }

  render() {

    if (!this.props.site
        && this.props.location.pathname !== routes.SELECT_SITE
        && !this.props.appLoading) {
      return <Redirect to={routes.SELECT_SITE} />;
    }

    if (!this.props.appLoading
        && this.props.isAuthenticated
        && this.props.user
        && !this.props.user.has_social_login
        && this.props.location.pathname !== routes.CONNECT_SOCIAL
        && this.props.location.pathname !== routes.FB_CALLBACK) {
      return <Redirect to={routes.CONNECT_SOCIAL} />;
    }

    if (!this.props.appLoading
        && this.props.isAuthenticated
        && this.props.user
        && this.props.user.has_social_login
        && this.props.user.is_complete === false
        && !this.props.location.pathname.startsWith(routes.COMPLETE_PROFILE_STARTSWITH)
        && !this.props.location.pathname.startsWith(routes.PROFILE_STATUS)) {
      return <Redirect to={routes.COMPLETE_PROFILE_STEP1} />;
    }

    if (!this.props.appLoading
        && this.props.isAuthenticated
        && this.props.user
        && this.props.user.has_social_login
        && this.props.user.is_complete === true
        && this.props.user.state !== 1
        && this.props.user.state !== 2
        && this.props.user.state !== 4
        && !this.props.location.pathname.startsWith(routes.PROFILE_STATUS)) {
      return <Redirect to={routes.PROFILE_STATUS} />;
    }

    if (!this.props.appLoading) {
      let urls = (
        <Switch>
          <Route path={routes.DISCLAIMER_MENU} component={DisclaimersMenu} />
          <Route path={routes.TERMS_AND_CONDITION} component={TermsAndConditions} />
          <Route path={routes.SELECT_SITE} component={SiteSelect} />
          <Route path={routes.LOGIN} component={Login} />
          <Route path={routes.FB_CALLBACK} component={FBCallback} />
          <Route path={routes.PASSWORD_RESET} component={PasswordReset} />
          <Route path={routes.SET_PASSWORD} component={SetPassword} />
          <Route path={routes.EVENTS} exact component={Events} />
          <Route path={routes.NEWS} exact component={News} />
          <Route path={routes.EVENT_DETAIL} exact component={EventDetail} />
          <Route path={routes.NEWS_DETAIL} exact component={NewsDetail} />
          <Route path={routes.STATIC_PAGES} exact component={StaticPages} />
          <Route path={routes.GALLERY} exact component={Gallery} />
          <Route path={routes.FAQS} exact component={FAQs}/>
          <Route path={routes.GALLERY_DETAIL} exact component={GalleryDetail} />
          <Route path="/" exact component={Home} />
          <Redirect to="/" />
        </Switch>
      );

      if (this.props.isAuthenticated && this.props.site) {
        urls = (
          <Switch>
            <Route path={routes.CONNECT_SOCIAL} component={ConnectSocialAuth} />
            <Route path={routes.FB_CALLBACK} component={FBCallback} />
            <Route path={routes.COMPLETE_PROFILE} exact component={CompleteProfile} />
            <Route path={routes.PROFILE_STATUS} exact component={ProfileStatus} />
            <Route path={routes.VIEW_PROFILE} exact component={ViewProfile} />
            <Route path={routes.EDIT_PROFILE} exact component={EditProfile} />
            <Route path={routes.PRINT_PROFILE} exact component={PrintProfile} />
            <Route path={routes.ACTIVITIES} exact component={Activities} />
            <Route path={routes.MANAGE_ACTIVITY_ITEM} exact component={ManageActivityItem} />
            <Route path={routes.SEARCH_RESULTS} exact component={Search} />
            <Route path={routes.SAVED_SEARCHES} exact component={SavedSearch} />
            <Route path={routes.SEARCH_FORM} exact component={SearchForm} />
            <Route path={routes.EVENTS} exact component={Events} />
            <Route path={routes.NEWS} exact component={News} />
            <Route path={routes.EVENT_DETAIL} exact component={EventDetail} />
            <Route path={routes.NEWS_DETAIL} exact component={NewsDetail} />
            <Route path={routes.STATIC_PAGES} exact component={StaticPages} />
            <Route path={routes.DELETE_PROFILE} exact component={DeleteProfile} />
            <Route path={routes.GALLERY} exact component={Gallery} />
            <Route path={routes.FAQS} exact component={FAQs} />
            <Route path={routes.GALLERY_DETAIL} exact component={GalleryDetail} />
            <Route path="/" exact component={DashHome} />
            <Redirect to="/" />

          </Switch>
        );
      }

      return urls;
    }

    return (
      <Layout rootClass={classes.appLoadingWrapper}>
        <CircularProgress align="center" size={100} />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appLoading: state.common.appLoading,
    isAuthenticated: state.auth.token !== null,
    site: state.common.site,
    token: state.auth.token,
    user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkAuth: () => dispatch(authActions.checkAuth()),
    getProfileStatus: token => dispatch(profileActions.getProfileStatus(token))
  };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js